import React from 'react';

import PlatformsBox from './SkillsAndExperience/PlatformsBox';
import Introduction from './static/Introduction';

class Home extends React.Component {

    render() {
        return (

            <section>
                <Introduction/>
                <PlatformsBox/>
            </section>
        );
    }
}

export default Home



// WEBPACK FOOTER //
// src/Home.js